export const RouteStepEnum = {
    DELIVERED: "DELIVERED",
    DELIVERY: "DELIVERY",
    IN_TRANSIT: "IN_TRANSIT",
    CREATED: "CREATED",
}